import {
  WSElementColorsType,
  WSPillProps
} from "@wingspanhq/fe-component-library";
import {
  Payout,
  PayoutStatus,
  PayoutTransferPurpose,
  PayoutTransferStatus
} from "@wingspanhq/wingspan-api-sdk";
import { getStatusDescriptionText } from "./getStatusDescriptionText";

export enum PayoutTableStatus {
  InProgress = "InProgress",
  Failed = "Failed",
  Deposited = "Deposited"
}

export function getTableStatus(payout: Payout): PayoutTableStatus {
  const transfers = payout.transfers.filter(transfer => {
    if (transfer.purpose === PayoutTransferPurpose.DISBURSEMENT) {
      return true;
    }
    if (transfer.purpose === PayoutTransferPurpose.WALLET_REMAINDER) {
      return !!transfer.amount;
    }
    if (transfer.purpose === PayoutTransferPurpose.TAX_WITHHOLDING) {
      return !!transfer.amount;
    }
    return false;
  });

  const allTransfersComplete = transfers.every(
    transfer => transfer.status === PayoutTransferStatus.SENT
  );

  if (allTransfersComplete || payout.status === PayoutStatus.COMPLETE) {
    return PayoutTableStatus.Deposited;
  }

  if (payout.status === PayoutStatus.FAILED) {
    return PayoutTableStatus.Failed;
  }

  return PayoutTableStatus.InProgress;
}

export const getPayoutsStatusPillProps = (payout: Payout): WSPillProps => {
  const tableStatus = getTableStatus(payout);

  switch (tableStatus) {
    case PayoutTableStatus.Deposited:
      return {
        theme: "success",
        icon: "check-circle",
        text: "Deposited"
      };

    case PayoutTableStatus.Failed:
      return {
        theme: "error",
        icon: true,
        text: "Payout failed"
      };

    default:
      return {
        theme: "blue",
        icon: "send-mail",
        text: "In-progress"
      };
  }
};

export const getPayoutStatusTableCellProps = (
  payout: Payout
): {
  pill: WSPillProps;
  secondaryTextColor: WSElementColorsType;
  secondaryText: string | undefined;
} => {
  const tableStatus = getTableStatus(payout);

  const pill = getPayoutsStatusPillProps(payout);
  const secondaryTextColor =
    tableStatus === PayoutTableStatus.Failed ? "red400" : "gray400";
  const secondaryText = getStatusDescriptionText(payout);

  return { pill, secondaryTextColor, secondaryText };
};
